resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function VerticallyCenter() {
    this.id = null;
    this.node = null;
    this.extends = [_ContentLayout, _ResponsiveLayout];

    this._scope = null;

    this.init = function() {
        this._scope = $(this.node).parent()[0];

        $(this.node).show();
        $(this._scope).css("position", "relative");
    };

    this.initAllReady = function() {
        this.registerResponsiveFunction($.proxy(this.reLayout, this), null, null)
    };

    this.reLayout = function() {
        var contentHeight = $(this.node).outerHeight();

        // Reset
        $(this.node).css("margin-top", 0);

        // Apply
        if ($(this.node).css("position") == "absolute") {
            $(this.node).css("top", "50%");
            $(this.node).css("margin-top", -contentHeight/2 + "px");
        } else {
            var wrapper = $(this._scope).height();
            $(this.node).css('margin-top', ((wrapper/2) - (contentHeight/2)) + "px");
        }
    };
}